import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { withComponentPreview } from '@wix/editor-elements-preview-utils';
import type React from 'react';
import type { IStylableButtonProps } from '../StylableButton.types';

export default (ViewerComponent: React.ComponentType<IStylableButtonProps>) =>
  createComponentPreviewEntry(withComponentPreview(ViewerComponent));
